
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(087|767|905)|1(121|198|689)|5(093|252|275|373|700)|3(233|341|429)|6931|8172|8878)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
